import React, { createContext, useContext, useEffect, useState } from "react";

export const dict = {
  tr: {
    nav: { features: "Özellikler", modules: "Modüller", product: "Ürün", login: "Giriş Yap", start: "Hemen Başla", toApp: "Uygulamaya Git" },
    hero: {
      eyebrow: "İRA Mühendislik'ten",
      line1: "Finansınızın",
      line2: "tam kontrolü,",
      line3: "tek ekranda.",
      sub: "Gelirler, giderler, banka hesapları, cari hesaplar, yaklaşan ödemeler ve tahsilatlar — hepsi tek yerden. Finansal raporlar oluşturun, nakit akışınızı anlık takip edin.",
      ctaPrimary: "Hemen Başla",
      ctaSecondary: "Özellikleri gör",
      caption: "Nakit akışını anlık izleyin",
      mockTitle: "Genel Bakış",
      mockIncome: "Bu Ay Gelir", mockExpense: "Bu Ay Gider", mockNet: "Net Akış", mockBalance: "Toplam Bakiye",
      live: "Canlı", months: ["Oca", "Şub", "Mar", "Nis", "May", "Haz", "Tem", "Ağu", "Eyl", "Eki", "Kas", "Ara"],
    },
    marquee: ["Nakit Akışı", "Banka Hesapları", "Cari Hesaplar", "Yaklaşan Ödemeler", "Tahsilatlar", "Finansal Raporlar", "Gelir-Gider", "Anlık Takip"],
    bento: {
      label: "Özellikler",
      title: "Tüm finans operasyonunuz, bir arayüzde",
      sub: "Dağınık tablolara ve tahminlere veda edin. İRA Finans her kuruşun nereden gelip nereye gittiğini tek ekranda gösterir.",
      items: [
        { t: "Anlık nakit akışı", d: "Gelir ve giderleriniz tek akışta; net bakiyeniz her hareketle anında güncellenir." },
        { t: "Banka hesapları", d: "Tüm hesaplarınız, IBAN'ları ve bakiyeleri tek tabloda." },
        { t: "Cari hesaplar", d: "Müşteri ve tedarikçi borç-alacak durumu elinizin altında." },
        { t: "Ödemeler & tahsilatlar", d: "Vadesi yaklaşan ödemeler ve bekleyen tahsilatlar; hiçbiri gözden kaçmaz." },
        { t: "Finansal raporlar", d: "Aylık karşılaştırma, kategori dağılımı ve cari bazlı raporlar hazır." },
      ],
    },
    modules: {
      label: "Modüller",
      title: "Giriş yapın, hepsini kullanın",
      sub: "Kayıt olduğunuz anda tüm modüller hesabınızda hazır ve örnek verilerle dolu olarak sizi bekler.",
      items: [
        { t: "Gelir & Gider", d: "Hareketleri saniyeler içinde girin; kategori, cari ve banka bağlayın." },
        { t: "Banka Hesapları", d: "TL, vadeli ve döviz hesaplarınız; bakiyeler otomatik güncellenir." },
        { t: "Cari Hesaplar", d: "Müşteri ve tedarikçi bakiyeleri bekleyen tahsilat ve ödemelerden otomatik hesaplanır." },
        { t: "Yaklaşan Ödemeler", d: "Vade takvimi, gecikmiş ödeme uyarısı ve tek tıkla 'ödendi' işaretleme." },
        { t: "Tahsilatlar", d: "Bekleyen alacaklarınızı izleyin, tahsil edildiğinde banka ve nakit akışı kendiliğinden güncellensin." },
        { t: "Finansal Raporlar", d: "12 aylık gelir-gider, kategori dağılımı ve cari bazlı alacak analizi." },
      ],
    },
    product: { label: "Ürün", title: "Ekranlar sade, rakamlar net", sub: "Sade ve temiz bir arayüz: en çok kullandığınız rakamlar açılışta karşınızda." },
    about: {
      quote: "Finans yönetimi, mühendislik disipliniyle.",
      sub: "İRA Mühendislik tarafından tasarlandı: net, hızlı ve güvenilir.",
    },
    cta: { title: "Finansal kontrolünüzü bugün ele alın", sub: "Hesabınızı oluşturun, örnek verilerle tüm modülleri hemen deneyin.", button: "Hemen Başla" },
    footer: { rights: "Tüm hakları saklıdır.", product: "Ürün", account: "Hesap" },
    auth: {
      loginTitle: "Tekrar hoş geldiniz",
      loginSub: "Hesabınıza giriş yapın.",
      registerTitle: "Finansal kontrolü ele alın",
      registerSub: "Hesabınızı oluşturun, tüm modüller örnek verilerle hazır gelsin.",
      name: "Ad Soyad", company: "Şirket (opsiyonel)", email: "E-posta", password: "Şifre",
      login: "Giriş Yap", register: "Hesap Oluştur",
      noAccount: "Hesabınız yok mu?", toRegister: "Kayıt olun",
      haveAccount: "Zaten hesabınız var mı?", toLogin: "Giriş yapın",
      demoHint: "Demo hesabı",
      working: "Gönderiliyor…",
    },
    app: {
      dashboard: "Genel Bakış", transactions: "Hareketler", recurring: "Tekrarlayan", banks: "Banka Hesapları", cari: "Cari Hesaplar",
      payments: "Ödemeler", receivables: "Tahsilatlar", budgets: "Bütçeler", reports: "Raporlar", team: "Ekip", logout: "Çıkış Yap",
      income: "Gelir", expense: "Gider", all: "Tümü", customer: "Müşteri", supplier: "Tedarikçi",
      pending: "Bekliyor", paid: "Ödendi", collected: "Tahsil Edildi", overdue: "Gecikti",
      add: "Ekle", edit: "Düzenle", delete: "Sil", save: "Kaydet", cancel: "Vazgeç",
      noData: "Kayıt bulunmuyor", amount: "Tutar", date: "Tarih", dueDate: "Vade Tarihi",
      description: "Açıklama", category: "Kategori", bank: "Banka Hesabı", cari: "Cari", status: "Durum",
      title: "Başlık", notes: "Not", name: "Hesap / Cari Adı", actions: "İşlem", confirmDelete: "Bu kayıt silinsin mi?",
      loading: "Yükleniyor…",
    },
    dash: {
      totalBalance: "Toplam Banka Bakiyesi", monthIncome: "Bu Ay Gelir", monthExpense: "Bu Ay Gider",
      monthNet: "Bu Ay Net Akış", pendingReceivables: "Bekleyen Tahsilat", upcoming: "Yaklaşan Ödemeler",
      cashflow: "Nakit Akışı — Son 6 Ay", recent: "Son Hareketler", accounts: "Banka Hesapları",
      overdueRecs: "gecikmiş tahsilat", overduePays: "gecikmiş ödeme", viewAll: "Tümünü gör",
      overdueNote: "Ödenmesi gereken gecikmiş ödeme",
    },
    txn: { new: "Yeni Hareket", newIncome: "Gelir Ekle", newExpense: "Gider Ekle", edit: "Hareketi Düzenle", excel: "Excel İndir", from: "Başlangıç", to: "Bitiş" },
    banksP: { new: "Hesap Ekle", edit: "Hesabı Düzenle", accountName: "Hesap Adı", bankName: "Banka", iban: "IBAN", balance: "Açılış Bakiyesi", currency: "Para Birimi", type: "Hesap Türü" },
    cariP: { new: "Cari Ekle", edit: "Cariyi Düzenle", type: "Cari Türü", tax: "Vergi No", phone: "Telefon", balance: "Bekleyen Bakiye", statement: "Ekstre", statementTitle: "Cari Ekstre", period: "Dönem" },
    doc: {
      title: "İşlem Dökümü", no: "Belge No", preparedBy: "Hazırlayan", records: "Kayıt Sayısı",
      pendingRec: "Bekleyen Tahsilatlar", pendingPay: "Bekleyen Ödemeler", balance: "Bakiye",
      sign: "İmza", eNote: "Bu belge İRA Finans tarafından elektronik olarak oluşturulmuştur.",
    },
    payP: { new: "Ödeme Ekle", edit: "Ödemeyi Düzenle", markPaid: "Ödendi", paidOn: "Ödendi" },
    recP: { new: "Tahsilat Ekle", edit: "Tahsilatı Düzenle", collect: "Tahsil Et", collectedOn: "Tahsil Edildi" },
    rep: {
      title: "Finansal Raporlar", monthly: "Aylık Gelir-Gider (12 Ay)", expCat: "Gider Kategori Dağılımı",
      incCat: "Gelir Kategorileri", topCari: "Cari Bazlı Bekleyen Alacaklar", totalIncome: "Toplam Gelir",
      totalExpense: "Toplam Gider", totalNet: "Net Kâr", noCari: "Bekleyen alacak yok",
    },
    rec: {
      title: "Tekrarlayan Kayıtlar", new: "Tekrarlayan Ekle", edit: "Kaydı Düzenle",
      frequency: "Sıklık", monthly: "Aylık", weekly: "Haftalık", yearly: "Yıllık",
      dayOfMonth: "Ayın Günü", startDate: "Başlangıç Tarihi", nextDate: "Sonraki Kayıt",
      active: "Aktif", paused: "Duraklatıldı",
      desc: "Seçtiğiniz günde hareket kendiliğinden oluşur; bakiyeler ve raporlar anında güncellenir.",
    },
    budget: {
      title: "Bütçeler", new: "Bütçe Ekle", edit: "Bütçeyi Düzenle", limit: "Aylık Limit",
      spent: "Bu Ay Harcanan", remaining: "Kalan", overBudget: "Bütçe aşıldı", nearLimit: "Limite yaklaşıyor",
      onTrack: "Bütçe dahilinde", empty: "Henüz bütçe tanımlanmadı",
    },
    rem: { on: "Vade hatırlatıcıları açık", off: "Vade hatırlatıcıları kapalı" },
    pdf: { download: "PDF İndir", excel: "Excel İndir", preparing: "Hazırlanıyor…" },
    dashFx: { label: "Canlı kur", updated: "Güncellendi", trend: "Kur Trendi — Son 30 Gün" },
    team: {
      title: "Ekip", inviteTitle: "Üye Davet Et", role: "Rol",
      owner: "Hesap Sahibi", editor: "Editör", viewer: "Görüntüleyici",
      members: "Üyeler", invites: "Bekleyen Davetler", send: "Davet Gönder",
      remove: "Kaldır", memberOf: "Üyesi olduğunuz hesap", leave: "Hesaptan Ayrıl",
      leaveConfirm: "Bu hesaptan ayrılmak istiyor musunuz? Kendi verilerinize geri dönersiniz.",
      viewerNote: "Görüntüleme modu", sent: "Davet e-postayla gönderildi",
      copyLink: "Bağlantıyı kopyala", copied: "Bağlantı kopyalandı", you: "siz", cancel: "İptal Et",
    },
    inv: {
      title: "Ekip Daveti", invitedBy: "sizi İRA Finans ekibine davet etti",
      asRole: "Rolünüz", join: "Ekibe Katıl",
      needAuth: "Devam etmek için giriş yapın veya kayıt olun.",
      invalid: "Davet bulunamadı veya daha önce kullanılmış.",
      emailNote: "Davet şu adrese gönderildi",
    },
    catIncome: ["Hizmet Geliri", "Ürün Satışı", "Danışmanlık", "Faiz Geliri", "Tahsilat", "Diğer"],
    catExpense: ["Kira", "Maaş", "Yazılım Aboneliği", "Pazarlama", "Ofis Giderleri", "Vergi", "Ödeme", "Diğer"],
  },
  en: {
    nav: { features: "Features", modules: "Modules", product: "Product", login: "Sign in", start: "Get Started", toApp: "Open App" },
    hero: {
      eyebrow: "By İRA Mühendislik",
      line1: "Total command",
      line2: "of your finances,",
      line3: "one screen.",
      sub: "Income, expenses, bank accounts, current accounts, upcoming payments and receivables — all in one place. Build financial reports and track cash flow in real time.",
      ctaPrimary: "Get Started",
      ctaSecondary: "See features",
      caption: "Track cash flow in real time",
      mockTitle: "Overview",
      mockIncome: "Income (MTD)", mockExpense: "Expenses (MTD)", mockNet: "Net Flow", mockBalance: "Total Balance",
      live: "Live", months: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
    },
    marquee: ["Cash Flow", "Bank Accounts", "Current Accounts", "Upcoming Payments", "Receivables", "Financial Reports", "Income & Expense", "Real-Time Tracking"],
    bento: {
      label: "Features",
      title: "Your entire finance operation, one interface",
      sub: "Say goodbye to scattered spreadsheets and guesswork. İRA Finans shows where every lira comes from and where it goes — on a single screen.",
      items: [
        { t: "Real-time cash flow", d: "Income and expenses in a single stream; your net balance updates instantly with every entry." },
        { t: "Bank accounts", d: "All your accounts, IBANs and balances in one table." },
        { t: "Current accounts", d: "Customer and supplier debt-credit status at your fingertips." },
        { t: "Payments & receivables", d: "Upcoming payments and pending collections — nothing slips through." },
        { t: "Financial reports", d: "Monthly comparisons, category breakdowns and per-account reports, ready to go." },
      ],
    },
    modules: {
      label: "Modules",
      title: "Sign in and use them all",
      sub: "The moment you register, every module is ready in your account, pre-filled with sample data.",
      items: [
        { t: "Income & Expense", d: "Record entries in seconds; attach category, account and bank." },
        { t: "Bank Accounts", d: "TRY, savings and FX accounts; balances update automatically." },
        { t: "Current Accounts", d: "Customer and supplier balances computed automatically from pending items." },
        { t: "Upcoming Payments", d: "Due calendar, overdue alerts and one-click 'mark as paid'." },
        { t: "Receivables", d: "Track pending receivables; when collected, bank and cash flow update themselves." },
        { t: "Financial Reports", d: "12-month income/expense, category breakdown and per-account analysis." },
      ],
    },
    product: { label: "Product", title: "Clean screens, crisp numbers", sub: "A deliberately minimal interface: the numbers you use most greet you on launch." },
    about: { quote: "Financial management, with engineering discipline.", sub: "Designed by İRA Mühendislik: clear, fast and reliable." },
    cta: { title: "Take control of your finances today", sub: "Create your account and try every module with sample data right away.", button: "Get Started" },
    footer: { rights: "All rights reserved.", product: "Product", account: "Account" },
    auth: {
      loginTitle: "Welcome back",
      loginSub: "Sign in to your account.",
      registerTitle: "Take financial control",
      registerSub: "Create your account and every module comes pre-filled with sample data.",
      name: "Full name", company: "Company (optional)", email: "Email", password: "Password",
      login: "Sign in", register: "Create account",
      noAccount: "No account yet?", toRegister: "Sign up",
      haveAccount: "Already have an account?", toLogin: "Sign in",
      demoHint: "Demo account",
      working: "Sending…",
    },
    app: {
      dashboard: "Overview", transactions: "Transactions", recurring: "Recurring", banks: "Bank Accounts", cari: "Current Accounts",
      payments: "Payments", receivables: "Receivables", budgets: "Budgets", reports: "Reports", team: "Team", logout: "Sign out",
      income: "Income", expense: "Expense", all: "All", customer: "Customer", supplier: "Supplier",
      pending: "Pending", paid: "Paid", collected: "Collected", overdue: "Overdue",
      add: "Add", edit: "Edit", delete: "Delete", save: "Save", cancel: "Cancel",
      noData: "No records yet", amount: "Amount", date: "Date", dueDate: "Due date",
      description: "Description", category: "Category", bank: "Bank account", cari: "Account", status: "Status",
      title: "Title", notes: "Notes", name: "Account name", actions: "Actions", confirmDelete: "Delete this record?",
      loading: "Loading…",
    },
    dash: {
      totalBalance: "Total Bank Balance", monthIncome: "Income (MTD)", monthExpense: "Expenses (MTD)",
      monthNet: "Net Flow (MTD)", pendingReceivables: "Pending Receivables", upcoming: "Upcoming Payments",
      cashflow: "Cash Flow — Last 6 Months", recent: "Recent Transactions", accounts: "Bank Accounts",
      overdueRecs: "overdue receivables", overduePays: "overdue payments", viewAll: "View all",
      overdueNote: "overdue payment due",
    },
    txn: { new: "New Entry", newIncome: "Add Income", newExpense: "Add Expense", edit: "Edit Entry", excel: "Download Excel", from: "From", to: "To" },
    banksP: { new: "Add Account", edit: "Edit Account", accountName: "Account name", bankName: "Bank", iban: "IBAN", balance: "Opening balance", currency: "Currency", type: "Account type" },
    cariP: { new: "Add Account", edit: "Edit Account", type: "Type", tax: "Tax no", phone: "Phone", balance: "Pending balance", statement: "Statement", statementTitle: "Account Statement", period: "Period" },
    doc: {
      title: "Transaction Statement", no: "Document No", preparedBy: "Prepared by", records: "Record Count",
      pendingRec: "Pending Receivables", pendingPay: "Pending Payments", balance: "Balance",
      sign: "Signature", eNote: "This document was generated electronically by İRA Finans.",
    },
    payP: { new: "Add Payment", edit: "Edit Payment", markPaid: "Mark paid", paidOn: "Paid" },
    recP: { new: "Add Receivable", edit: "Edit Receivable", collect: "Collect", collectedOn: "Collected" },
    rep: {
      title: "Financial Reports", monthly: "Monthly Income vs Expense (12M)", expCat: "Expense Breakdown",
      incCat: "Income Breakdown", topCari: "Pending Receivables by Account", totalIncome: "Total Income",
      totalExpense: "Total Expense", totalNet: "Net Profit", noCari: "No pending receivables",
    },
    rec: {
      title: "Recurring Entries", new: "Add Recurring", edit: "Edit Entry",
      frequency: "Frequency", monthly: "Monthly", weekly: "Weekly", yearly: "Yearly",
      dayOfMonth: "Day of Month", startDate: "Start Date", nextDate: "Next Run",
      active: "Active", paused: "Paused",
      desc: "Entries are created automatically on the chosen day; balances and reports update instantly.",
    },
    budget: {
      title: "Budgets", new: "Add Budget", edit: "Edit Budget", limit: "Monthly Limit",
      spent: "Spent (MTD)", remaining: "Remaining", overBudget: "Over budget", nearLimit: "Near limit",
      onTrack: "On track", empty: "No budgets defined yet",
    },
    rem: { on: "Due-date reminders on", off: "Due-date reminders off" },
    pdf: { download: "Download PDF", excel: "Download Excel", preparing: "Preparing…" },
    dashFx: { label: "Live rate", updated: "Updated", trend: "FX Trend — Last 30 Days" },
    team: {
      title: "Team", inviteTitle: "Invite a Member", role: "Role",
      owner: "Owner", editor: "Editor", viewer: "Viewer",
      members: "Members", invites: "Pending Invites", send: "Send Invite",
      remove: "Remove", memberOf: "Account you belong to", leave: "Leave Account",
      leaveConfirm: "Leave this account? You will return to your own data.",
      viewerNote: "View-only mode", sent: "Invite sent by email",
      copyLink: "Copy link", copied: "Link copied", you: "you", cancel: "Cancel",
    },
    inv: {
      title: "Team Invitation", invitedBy: "invited you to their İRA Finans team",
      asRole: "Your role", join: "Join the Team",
      needAuth: "Sign in or register to continue.",
      invalid: "Invitation not found or already used.",
      emailNote: "Invitation was sent to",
    },
    catIncome: ["Service Revenue", "Product Sales", "Consulting", "Interest Income", "Collection", "Other"],
    catExpense: ["Rent", "Payroll", "Software", "Marketing", "Office", "Tax", "Payment", "Other"],
  },
};

const I18nCtx = createContext(null);

export function I18nProvider({ children }) {
  const [lang, setLangState] = useState(() => localStorage.getItem("ira-lang") || "tr");
  useEffect(() => {
    localStorage.setItem("ira-lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);
  const t = dict[lang];
  const fmt = (n, currency = "TRY") =>
    new Intl.NumberFormat(lang === "tr" ? "tr-TR" : "en-US", {
      style: "currency", currency, maximumFractionDigits: 2, minimumFractionDigits: 0,
    }).format(n || 0);
  const fmtDate = (d) => {
    if (!d) return "—";
    const dt = new Date(d + (d.length === 10 ? "T00:00:00" : ""));
    return dt.toLocaleDateString(lang === "tr" ? "tr-TR" : "en-US", { day: "numeric", month: "short", year: "numeric" });
  };
  const monthLabel = (key) => {
    const m = parseInt(key.slice(5, 7), 10) - 1;
    return `${t.hero.months[m]} ${key.slice(2, 4)}`;
  };
  return (
    <I18nCtx.Provider value={{ lang, setLang: setLangState, t, fmt, fmtDate, monthLabel }}>
      {children}
    </I18nCtx.Provider>
  );
}

export const useI18n = () => useContext(I18nCtx);
